class Waitlist extends Events
{
  add (donorId, motCategories)
  {
    return new Promise((resolve, reject) => {
      const donorGid = encodeURIComponent('gid://shopify/Product/' + donorId);

      fetch(app.apiUrl('customer-subscriptions/donors/' + donorGid), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...app.apiHeaders()
        },
        body: JSON.stringify({
          mot_categories: motCategories
        })
      }).then(res => res.json())
        .then(data => {
          if (!data) {
            console.error('Failed to add waitlist:', data);

            reject(null);
          } else {
            resolve(data.data);
          }
        })
        .catch(error => reject(error));
    });
  }
}